import React from "react";
import AuthRoutes from "./routes";
import loadable from "@loadable/component";

const Layout = loadable(() => import("./layout"));

const Authentication = () => {
  return (
    <Layout>
      <AuthRoutes />
    </Layout>
  );
};
export default Authentication;
